import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import socket from "../../assets/socketConnection";
import { submitPreReqAsyncSuccess } from "../../redux/preReq/preReq.actions";
import { AlertNotifStyled } from "./alertNotif.styles";
import { selectAlertNotifShow } from "../../redux/newRequest/newRequest.selectors";
import { setAlertNotifShow } from "../../redux/newRequest/newRequest.actions";
const AlertNotif = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const alertNotif = useSelector(selectAlertNotifShow);
  const setAlertData = (message) => {
    setMessage(message);
    setShow(true);
  };
  // useEffect(() => {
  //   console.log(alertNotif);
  //   if (alertNotif) {
  //     setAlertData("لطفا جزئیات بیشتر بار خود را تکمیل نمایید");
  //   }
  // }, [alertNotif]);
  const onCancell = () => {
    setShow(false);
    // dispatch(setAlertNotifShow(false));
  };
  useEffect(() => {
    socket.on("response_notif", ({ type, message }) => {
      // alert("notif");
      setAlertData(message);
      //   switch (type) {
      //     case 0:
      //       alert("0");
      //       // handle_alert(message);
      //       break;
      //     default:
      //       break;
      //   }
    });
    socket.on("response_notif_request_load", ({ type, message }) => {
      setAlertData(message);
      // debugger;

      // updateReqResponse(data);
      // if(data.type )
      // alert("hiasdf");
    });
    socket.on("response_new_instant_request", (data) => {
      // alert("resp");
      // console.log(data);
      const { message, load_id, type } = data;

      dispatch(submitPreReqAsyncSuccess(data));

      if (type === 0) {
        setAlertData(message);
      } else if (type === 1) {
        history.push(`/new-req/instant/${load_id}`);
      }
    });

    // return () => {
    //     cleanup
    // }
  }, []);

  return (
    // <Animated
    //   animationIn="zoomInUp"
    //   animationOut="bounceOutUp"
    //   animationInDuration={500}
    //   animationOutDuration={500}
    //   isVisible={show}
    //   className="animated position-fixed w-100 h-100"
    //   style={{ position: "fixed", top: 0, left: 0, zIndex: "99999" }}
    // >
    <AlertNotifStyled show={show}>
      <div className="alert-page__inner">
        <div>{message}</div>
        <div className="d-flex align-items-center justify-content-center w-100 flex-column mt-3">
          <button className="alert-page__btn btn" onClick={() => onCancell()}>
            باشه
          </button>
        </div>
      </div>
    </AlertNotifStyled>
    // </Animated>
  );
};

export default AlertNotif;
